import { render } from "./BigBagPage.vue?vue&type=template&id=3f76eeee&scoped=true"
import script from "./BigBagPage.vue?vue&type=script&lang=js"
export * from "./BigBagPage.vue?vue&type=script&lang=js"

import "./BigBagPage.vue?vue&type=style&index=0&id=3f76eeee&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f76eeee"]])

export default __exports__